import {
  AboveGradeWallType,
  BelowGradeWallType,
  ExposureDirectionType,
  FootprintPolygonsType,
  PositionType
} from 'data/types';
import { edgeItemsFromWall } from 'utils/edge-items-from-wall';
import { hasAnyFootprintPolygon } from 'utils/footprint-polygons';
import { OpeningRunLayoutType } from 'utils/opening-run-layout-types';
import { edgeRunFromPolygonEdge } from 'utils/opening-layout';
import { assignWallsToPolygonEdges } from 'utils/polygon-exterior-walls';
import { getExteriorPolygonEdges } from 'utils/space-polygon';
import { wallCardinal } from 'utils/wall-cardinal';

type WallWithOpeningsType = AboveGradeWallType | BelowGradeWallType;

export function getPolygonEdgeOpeningRuns(params: {
  originFeet: PositionType;
  verticesFeet: PositionType[];
  footprints: FootprintPolygonsType | null;
  walls: WallWithOpeningsType[];
  homeOrientation: ExposureDirectionType | undefined;
}): OpeningRunLayoutType[] {
  const { originFeet, verticesFeet, footprints, walls, homeOrientation } =
    params;
  if (verticesFeet.length < 3) {
    return [];
  }

  const absoluteVertices = verticesFeet.map((vertex) => ({
    x: vertex.x + originFeet.x,
    y: vertex.y + originFeet.y
  }));
  const edges = getExteriorPolygonEdges(absoluteVertices, footprints);
  const hasFootprint = hasAnyFootprintPolygon(footprints);
  const wallsForEdges = assignWallsToPolygonEdges(
    edges,
    walls,
    (wall) => wallCardinal(wall, homeOrientation),
    homeOrientation
  );

  const layouts: OpeningRunLayoutType[] = [];
  edges.forEach((edge, index) => {
    const includeEdge = !hasFootprint || edge.isExterior;
    const run = includeEdge ? edgeRunFromPolygonEdge(edge, originFeet) : null;
    if (run) {
      const wall = wallsForEdges[index];
      layouts.push({
        run,
        items: wall ? edgeItemsFromWall(wall) : [],
        wallUniqueId: wall?.uniqueId
      });
    }
  });

  return layouts;
}
